export default "__VITE_ASSET__DvBya048__"